<template>
  <div>
    <div class="bgBanner" >
      <div class="baner1Text clff">
        <div class="t1 animate__animated animate__slideInLeft"  >企业介绍</div>
        <div class="t2  animate__animated animate__slideInRight">
          随便写点。智能选线大模型，快速评估路线可通行过性，让您选出的运输线路更快获批
        </div>
      </div>
    </div>
    <div class="case"  ref="section1">
      <navTitle title="服务案列" class="op0"  :class="getAnimationClass('section1', 'animate__fadeInUp')"></navTitle>
      <div class="caseList">
        <div class="items hoverBox"  :class="getAnimationClass('section1', 'animate__fadeInUp animate__delay-1s')">
          <img src="@/assets/images/contact/img1.png" width="380px" height="290px" alt="">
          <p class="ellipsis3">案例说明案例说明案例说明案例案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明说明</p>
        </div>
        <div class="items hoverBox"  :class="getAnimationClass('section1', 'animate__fadeInUp animate__delay-1_5s')">
          <img src="@/assets/images/contact/img2.png" width="380px" height="290px" alt="">
          <p class="ellipsis3">案例说明案例说明案例说明案例案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明说明</p>
        </div>
        <div class="items hoverBox"  :class="getAnimationClass('section1', 'animate__fadeInUp animate__delay-2s')">
          <img src="@/assets/images/contact/img3.png" width="380px" height="290px" alt="">
          <p class="ellipsis3">案例说明案例说明案例说明案例案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明案例说明说明</p>
        </div>
      </div>
    </div>
    <div class="contact"  ref="section2">
      <div class="w1200 clff pt150"  :class="getAnimationClass('section2', 'animate__fadeInUp animate__delay-05s')">
        <p class="fs48">联系我们</p>
        <p class="fs64">{{ contact.phone }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import navTitle from '@/components/navTitle/index.vue'
import { observers } from '@/mixins/observers'
import { getInfo } from '@/api/news'
import { setImgPath } from '@/utils/index'
export default {
  name: 'index',
  data() {
    return {
      aptitudeData: [],
      caseData: [],
    }
  },
  mixins: [observers],
  components: {
    navTitle
  },
  computed: {
    contact () {
      return this.$store.state.contact
    }
  },
  mounted() {
    this.getAptitude()
    this.getInfos()
  },
  methods: {
    async getInfos () {
      const { data } = await getInfo({
        categoryCode: 'CASE_SERVICE',
        limit: 4
      })
      this.caseData = data
    },
    async getAptitude () {
      const { data } = await getInfo({
        categoryCode: 'QUALIFICATION',
        limit: 3
      })
      this.aptitudeData = data
    },
    setImgPath,
  }
}
</script>


<style scoped lang="less">
.bgBanner{
  background: url('../../assets/images/contact/banner1.png') center no-repeat;
  background-size: cover;
  width: 100%;
  height: 100vh;
  position: relative;
  .baner1Text{
    width: 26.3%;
    position: absolute;
    margin-top: 15.62%;
    margin-left: 18.75%;
    text-align: left;
    .t1{
      font-size: 48px;
      font-weight: 700;
    }
    .t2{
      font-size: 25px;
      margin-top: 10px;
    }
  }
}
.advice{
  width: 1200px;
  margin: 0 auto;
  height: 750px;
  padding-top: 66px;
  .sort{
    width: 382px;
    height: 565px;
    background: #FFFFFF;
    margin-top: 38px;
    border-radius: 3px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  }
  .sort2{
    width: 435px;
    height: 640px;
    background: #FFFFFF;
    border-radius: 3px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    margin: 0 2px;
  }
}

.case{
  background: #F3F7FF;
  width: 100%;
  height: 684px;
  padding-top: 66px;
  .caseList{
    width: 1200px;
    margin: 0 auto;
    padding-top: 61px;
    display: flex;
    justify-content: space-between;
    .items{
      width: 380px;
      font-size: 28px;
      color: #0F3EAA;
      cursor: pointer;
    }
  }
}
.contact{
  width: 100%;
  height: 457px;
  background: url('../../assets/images/contact/banner2.png') center no-repeat;
}
</style>